<template>
  <div>
    <ul class="content_2">
      <a
        :href="'//' + item.url"
        target="_blank"
        v-for="(item, index) in list"
        :key="index"
      >
        <li :style="{ backgroundImage: `url(${item.image})` }">
          <p class="animated fadeInDown">{{ item.title }}</p>
          <span class="animated fadeInUp">{{ item.des }}</span>
        </li>
        <!-- <div class="content_fawer">
            <h4> {{index ==0?'广告一':index == 1?'广告二':''}}</h4>
            <p>关注地球的改善环境、研发和维护</p>
        </div> -->
      </a>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
};
</script>

<style scoped lang='less'>
.content_2 {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  a{
    display: flex;
    flex: 1;
    height: 151px;
    text-align: left;
    position: relative;
    &:first-child{
      margin-right: 16px;
    }
  }
  li {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    p {
      margin: 20px 0 0 20px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 8px;
    }

    span {
      margin: 20px 0 0 20px;
      font-size: 14px;
      font-family: STHeitiSC;
      font-weight: 300;
      color: #ffffff;
      line-height: 18px;
      opacity: 0.8;
    }
  }
  .content_fawer{
    position: absolute;
    top: 20px;
    left: 20px;
    h4{
      font-size: 22px;   
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    p{
      margin-top: 5px;
      font-size: 14px;    
      font-family: STHeitiSC;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 18px;
      opacity: 0.8;
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/advertisement.vue